import { render, staticRenderFns } from "./gtr-show-if.vue?vue&type=template&id=487f8d15&scoped=true"
import script from "./gtr-show-if.ts?vue&type=script&lang=ts&external"
export * from "./gtr-show-if.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-show-if.vue?vue&type=style&index=0&id=487f8d15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f8d15",
  null
  
)

export default component.exports